// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../core/resource.mjs";
export class Tags extends APIResource {
    /**
     * Get the list of all tags (from agents and blocks) that have been created.
     */
    list(query = {}, options) {
        return this._client.get('/v1/tags/', { query, ...options });
    }
}
//# sourceMappingURL=tags.mjs.map